import { EServiceGroup } from "@constants";
import { ICart, ICartAddon, ICartOffer } from "@features/cart/ICart";
import { centsToPrice } from "itsf-ui-common";

const SA_BB_ADDONS = "SA_BB_ADDONS";
type IDataLayerAddToCartEventEcommerceItemType = EServiceGroup | typeof SA_BB_ADDONS;

export interface IDataLayerEcommerceItem {
    itemName: string;
    price: number;
    quantity: number;
    type: IDataLayerAddToCartEventEcommerceItemType;
}

export const mapOfferToItem = ({
    baseOffer: { description, recurringChargeAmount, serviceGroup },
}: ICartOffer): IDataLayerEcommerceItem => ({
    itemName: description,
    price: Number(centsToPrice(recurringChargeAmount)),
    quantity: 1,
    type: serviceGroup,
});

export const mapAddonListToItem = (addonList: ICartAddon[]): IDataLayerEcommerceItem => ({
    itemName: addonList[0].description,
    price: Number(centsToPrice(addonList[0].amountVatIncluded.recurringAmount.amount)),
    quantity: addonList.length,
    type: SA_BB_ADDONS,
});

export const mapItems = (offers: ICartOffer[]) =>
    Object.values(
        offers.reduce<Record<string, IDataLayerEcommerceItem>>((acc, offer) => {
            const {
                addOns,
                baseOffer: { catalogOfferCode, serviceGroup },
            } = offer;

            if (EServiceGroup.SA_BB === serviceGroup && addOns.length > 0) {
                acc.SA_BB_ADDONS = mapAddonListToItem(addOns);
            }

            if (!acc[catalogOfferCode]) {
                acc[catalogOfferCode] = mapOfferToItem(offer);
            } else {
                acc[catalogOfferCode].quantity++;
            }

            return acc;
        }, {})
    );

export const getCartConfig = (items: IDataLayerEcommerceItem[]) => {
    const cartConfigList = [];
    if (items.find(({ type }) => EServiceGroup.SA_BB === type)) {
        cartConfigList.push("BROADBAND");
    }
    const mobile = items.find(({ type }) => EServiceGroup.MOBILE === type);
    if (mobile) {
        cartConfigList.push(`${mobile.quantity}MOBILE`);
    }
    const addOn = items.find(({ type }) => SA_BB_ADDONS === type);
    if (addOn) {
        cartConfigList.push(`${addOn.quantity}ADD_ON_BOOSTER`);
    }

    return cartConfigList.join(", ");
};

export const getCartTotal = (cart: ICart) => Number(centsToPrice(cart.recurringChargeAmount));

export const getTotalQuantity = (items: IDataLayerEcommerceItem[]) =>
    items.reduce((acc, item) => acc + item.quantity, 0);
